export default "__VITE_ASSET__Bjg_373K__"